import * as Sentry from '@sentry/react';
import { FetchArgs } from '@reduxjs/toolkit/dist/query';

export const sentryErrorCapture = (result: any, args: string | FetchArgs) => {
  const isArgsObject = typeof args === 'object';

  Sentry.captureException(result.error, {
    level: 'error',
    extra: {
      url: isArgsObject ? args?.url : args,
      method: isArgsObject ? args?.method : 'unknown',
      status: result.error?.status || 'Unknown',
      data: result?.error.data || null,
    },
  });
};
